import * as React from 'react';

const styles = require('./Logo.scss');

const Logo = () => (
    <div className={`${styles.logo}`} />
);

export default Logo;